<a [attr.href]="itemUrl" target="_blank">
    <button class="flex flex-row items-center align-middle gap-4 w-full p-2 hover:bg-white hover:bg-opacity-20 hover:cursor-pointer">
        <div>
            <svg class="w-5 h-5 fill-none stroke-slate-100 filter-icon-almost-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="svgIcon" />
            </svg>
        </div>
        <div class="grow text-left align-middle">
            View Card in New Tab
        </div>
        <div class="pr-2">
            →
        </div>
    </button>
</a>